import { Link } from "../../cms/blocks/types.gen";
import { isLinkExternal, linkWrapper } from "../../cms/blocks/utils.gen";
import { CustomRouteParams } from "../../cms/router/type.gen";
import { PublicSiteState } from "../../public_site.main.mod";
import { PublicSiteCustomRoutes } from "../custom_pages/types.mod";

export const enforceExternalLink = ({title, url}: { title: string; url: string }): Link => ({
  kind: 'link',
  is_link_external: true,
  target: isLinkExternal(url) ? '_blank' : '_self',
  title: title,
  url: url
})

export const proxyPageLinkWrapper = (route: CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>) =>
  route.kind == 'proxy_page' ? enforceExternalLink : linkWrapper
